import { ReactNode } from "react";

const PageTransition = ({ children }: { children: ReactNode }) => (
  <div>{children}</div>
);

export default PageTransition;
